import { useMutation } from "@apollo/client";

import { MapEditorPlannerAreaPanel_PlannerAreaSaveProtocolDocument } from "../../mutations.generated";
import { MapEditorPlannerAreaPanelDocument } from "../../queries.generated";

export function useSavePlannerAreaProtocolMutation() {
    const [mutate, result] = useMutation(MapEditorPlannerAreaPanel_PlannerAreaSaveProtocolDocument, {
        refetchQueries: [MapEditorPlannerAreaPanelDocument],
    });

    const savePlannerAreaProtocol = (plannerAreaId: string, protocolId: string) =>
        mutate({
            variables: {
                input: {
                    plannerAreaId,
                    protocolId,
                },
            },
        });

    return [savePlannerAreaProtocol, result] as const;
}
